import React, {Component} from 'react';
import Particles from 'react-particles-js';
import { Link } from "react-scroll";
export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDiv: "div1"
    }
  }
  toggleDiv = () => {
    this.setState({
      activeDiv: this.state.activeDiv === "div1" ? "div2" : "div1"

    });
  };

  render() {
    return (   
<div className="Main" id="Main">

<div className={this.state.activeDiv === "div1" ? "div1 show" : "div1 hide"} id="div1">
<div id='stars'></div>
<div id='stars2'></div>
<div id='stars3'></div>
<div className="greeting" >

    <h1>
    <span className='white'>I'm </span>
     MOHD ROHAAN <span className='white'>;)</span>
    </h1>
      <button type="button" onClick={this.toggleDiv} className='Greetingbutton'>Hi Rohaan! What you do?</button>
      <form className="resume-form" action="https://internshala.com/student/resume_download/93A08A14-3EF7-078A-F47E-B06A156FA04E/5222962">
      <button className="Greetingbutton" >DOWNLOAD RESUME</button> 
      </form>
      </div>
  
</div>

<div className={this.state.activeDiv === "div2" ? "div2 show" : "div2 hide"} id="div2">
  
<Particles
    params={{
      "particles": {
        "number": {
          "value": 80
        },
        "size": {
          "value": 4 
        }
      },
      "interactivity": {
        "events": {
          "onhover": {
            "enable": true,
            "mode": "repulse"
          }
        }
      }
    }} />   
  <div className="greeting">
<h1>
I'm a Full-stack<span className='white'> Web developer</span> and a <br/> <span className="white"> Data Scientist</span>.
</h1>
<h3>I am a Full-Stack Web-Developer. I have tremendous experience in web development. My expertise is in HTML CSS  and javascript. I work with PHP, React js, mongoDB and nodeJS.
Other than that I work with jupyter notebook. I have a very advance know of c/c++, java , python , JavaScript, goLang. I am always open to learning and adapt new technologies. I am a fast learner I am a passionate teacher and i love to teach people. I have a very fun and enjoyable way of teaching. I prefer project based learning. I love to try and learn new things. </h3>
  <button type="button" onClick={this.toggleDiv} className="Greetingbutton">GO BACK TO SPACE !!</button>
  <Link
              activeClass="active nav-item"
              to="Projects"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            > <button className="Greetingbutton">WOW Can i see your Projects?</button></Link>
 
 </div>
 
</div>
</div>
    )
  }
}